import getSelectedProduct from "./getSelectedProduct";
import addDisableOptionValue from "./addDisableOptionValue";

const getSelectedProductInformation = (product, options, selectedOptions) => {
  if (!product || !product.configurations || !options) {
    return {};
  }

  const selectedProduct = getSelectedProduct(
    product.configurations,
    selectedOptions
  );

  // The sku must not be updated in the product in order to avoid wrong
  // addToCart requests on configurable products
  const { sku: selectedSku, ...selectedProductProps } = selectedProduct
    ? selectedProduct
    : { sku: null };

  const optionsWithDisable = addDisableOptionValue(
    product.configurations,
    options,
    selectedOptions
  );
  const images =
    selectedProductProps.images && selectedProductProps.images.length > 0
      ? selectedProductProps.images
      : product.images;

  return {
    selectedProduct: {
      ...product,
      ...selectedProductProps,
      images,
      options: optionsWithDisable,
    },
    selectedSku,
    baseProduct: product,
  };
};

export default getSelectedProductInformation;
